import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { StringHelper } from 'src/app/helpers/string-helper';
import Address from 'src/app/model/project/address';
import {
  GOOGLE_MAPS_API_KEY,
  GOOGLE_MAPS_STREETVIEW_URL,
} from 'src/globals/globals';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GetStreetViewMetadataService {
  constructor(private http: HttpClient) {}

  public async getStreetViewLink(address: Address): Promise<string> {
    const requestAddress = this.getRequestAddress(address);

    if (StringHelper.isEmpty(requestAddress)) {
      return Promise.resolve(null);
    }

    const res = await this.getGoogleStreetViewResponse(
      requestAddress
    ).toPromise();

    if (this.isErrorStatus(res.status)) {
      throw new Error(res.status);
    }

    return res.pano_id;
  }

  private getRequestAddress(address: Address): string {
    return StringHelper.join(
      [
        address.line1,
        StringHelper.join([address.postalCode, address.city], ' '),
      ],
      ', '
    );
  }

  private getGoogleStreetViewResponse(
    requestAddress: string
  ): Observable<StreetViewMetadataResponse> {
    return this.http.get<StreetViewMetadataResponse>(
      `${GOOGLE_MAPS_STREETVIEW_URL}${requestAddress}&key=${GOOGLE_MAPS_API_KEY}`
    );
  }

  private isErrorStatus(status: StreetViewMetadataStatus): boolean {
    return !(
      status === StreetViewMetadataStatus.OK ||
      status === StreetViewMetadataStatus.ZERO_RESULTS
    );
  }
}

interface StreetViewMetadataResponse {
  pano_id?: string;
  status: StreetViewMetadataStatus;
}

enum StreetViewMetadataStatus {
  OK = 'OK',
  ZERO_RESULTS = 'ZERO_RESULTS',
  NOT_FOUND = 'NOT_FOUND',
  OVER_QUERY_LIMIT = 'OVER_QUERY_LIMIT',
  REQUEST_DENIED = 'REQUEST_DENIED',
  INVALID_REQUEST = 'INVALID_REQUEST',
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
}
